var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuredaAsociadosLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 731.47 152.49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;stroke:#fff;stroke-miterlimit:10;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_5",
    "data-name": "Capa 5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M204.85,126.23H187.72a5.93,5.93,0,0,0-4.51,1.88,5.51,5.51,0,0,0-1.28,2.91v16.14a5.33,5.33,0,0,0,1.49,3.25,5.54,5.54,0,0,0,4.3,1.52l17.13,0a6.12,6.12,0,0,0,4.81-2.21,5.26,5.26,0,0,0,1-2.58V131a5.68,5.68,0,0,0-1.66-3.28A5.75,5.75,0,0,0,204.85,126.23Zm-17.13,20.93V131h17.12v16.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M633.91,126.24H616.79a5.91,5.91,0,0,0-4.51,1.89A5.51,5.51,0,0,0,611,131q0,8.07,0,16.14a5.37,5.37,0,0,0,1.49,3.24,5.54,5.54,0,0,0,4.31,1.53l17.13,0a6.11,6.11,0,0,0,4.8-2.21,5.29,5.29,0,0,0,1-2.58V131a5.55,5.55,0,0,0-1.66-3.28A5.69,5.69,0,0,0,633.91,126.24Zm-17.12,20.93V131h17.12v16.14Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Capa_2-2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M604.68,5.65a20.93,20.93,0,0,0-13.7-5l-80.89,0V91.38l80.9.1c.88.09,10.65.87,16.63-6.52a18,18,0,0,0,3.86-10.38q0-28.5,0-57A20.86,20.86,0,0,0,604.68,5.65ZM591,74.58H530.51v-57l60.52,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M548.56,127.68a5.94,5.94,0,0,0-3.88-1.41H521.76v25.68l22.92,0a5.67,5.67,0,0,0,4.71-1.84,5,5,0,0,0,1.09-2.94q0-8.07,0-16.13A6,6,0,0,0,548.56,127.68Zm-3.88,19.51H527.55V131.05h17.15Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Capa_3",
    "data-name": "Capa 3"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "382.51 0.63 483.94 0.63 483.95 17.54 402.98 17.54 403 37.52 483.98 37.52 483.95 54.47 402.97 54.47 402.96 74.55 483.98 75.21 483.98 91.51 382.55 91.51 382.51 0.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M356.88,37.67l0-20A19.9,19.9,0,0,0,352.54,8C346.63.91,337.72.76,336.32.76H255.39V91.63l20.43-.07V54.63h39.68l20.82,36.9,20.49.1-20.48-37a21.32,21.32,0,0,0,15.26-6.3A20.52,20.52,0,0,0,356.88,37.67Zm-81.06,0V17.65l60.51,0V37.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M128.48.65l20.45,0V74.5l60.48.07V.65H230l-.05,73.92a19,19,0,0,1-4.71,10.74c-6,6.64-14.6,6.24-15.78,6.16l-60.48-.06a20.54,20.54,0,0,1-20.46-16.84Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "628.65 91.27 669.06 0.5 689.52 0.54 730.08 91.41 709.55 91.38 679.31 17.44 649.07 91.31 628.65 91.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M102.25.56l-81,0A21.5,21.5,0,0,0,7.05,6.17,21.15,21.15,0,0,0,.78,17.47l0,20A19.15,19.15,0,0,0,6.63,49.38a19.54,19.54,0,0,0,14.6,5l60.48.06v20H.77l0,16.93,80.9,0c2-.19,10.75-1.25,16.51-8.63a21.74,21.74,0,0,0,4-8.27q0-10,0-20.08A19.82,19.82,0,0,0,97.4,44c-6-6.59-14.31-6.54-15.65-6.51l-60.52,0v-20h81Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "362.99 126.39 368.74 126.4 368.75 151.94 362.99 151.93 362.99 126.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "431.5 151.91 442.95 126.21 448.74 126.22 460.22 151.94 454.41 151.94 445.85 131 437.29 151.92 431.5 151.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "0.77 151.91 12.21 126.21 18 126.22 29.48 151.94 23.67 151.93 15.11 131 6.55 151.92 0.77 151.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M120,126.23H97.05a6.15,6.15,0,0,0-4,1.6,6,6,0,0,0-1.77,3.2c0,1.88,0,3.77,0,5.65a5.37,5.37,0,0,0,1.65,3.38,5.51,5.51,0,0,0,4.13,1.42l17.12,0v5.67H91.26V152h22.9a6.84,6.84,0,0,0,4.68-2.44,6.33,6.33,0,0,0,1.12-2.34v-5.69a5.62,5.62,0,0,0-1.36-2.95,6,6,0,0,0-4.43-1.85l-17.13,0V131H120Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M731,126.22H708a5.91,5.91,0,0,0-5.79,4.79c0,1.89,0,3.77,0,5.66a5.39,5.39,0,0,0,1.65,3.38,5.6,5.6,0,0,0,4.13,1.42h17.12v5.67H702.25v4.79h22.9a6.84,6.84,0,0,0,4.68-2.44,6.26,6.26,0,0,0,1.12-2.34v-5.68a5.65,5.65,0,0,0-1.36-3,5.91,5.91,0,0,0-4.43-1.84H708V131H731Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M301.08,126.24h-22.9a5.69,5.69,0,0,0-4.15,1.5A5.58,5.58,0,0,0,272.4,131v16.12a5.56,5.56,0,0,0,1.75,3.36,5.65,5.65,0,0,0,4,1.4l22.89,0v-4.78H278.19V131h22.9Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuredaAsociadosLogo);
export default __webpack_public_path__ + "static/media/sureda_asociados--logo.655872f7.svg";
export { ForwardRef as ReactComponent };